export const BrandStory = () => {
    return (
        <figure className="relative w-full h-full flex flex-col items-start text-left justify-center bg-white text-black px-6 py-10 md:px-16 md:py-20 xl:pl-[120px] xl:pr-16 xl:py-40">
            <div className="flex flex-col gap-3 md:gap-4 text-[16px] md:text-[20px] lg:text-[24px] text-pretty leading-relaxed max-w-[1000px]">
                <p>나와 다른 얼굴을 보며 동경하는 시대는 지났습니다.</p>
                <p>저마다 갖고 있는 고유의 비주얼들을 살려주는 것이 뷰티의 정의가 되어야 합니다.</p>
                <p>EPYT는 차세대 뷰티 플랫폼으로서 개인의 고유한 미의 기준을 발견하게끔 돕습니다.</p>
            </div>

            <div className="w-full h-12 md:h-16 lg:h-20" />

            <div className="flex flex-col gap-3 md:gap-4 text-[16px] md:text-[20px] lg:text-[24px] text-pretty leading-relaxed max-w-[1000px]">
                <p>나만의 장점을 살리려면, 장점을 알고 있어야 합니다.</p>
                <p>그 장점을 EPYT와 함께 찾아보시길 바라며, 서비스를 제작하고 있습니다.</p>
            </div>
        </figure>
    );
};
